<template>
  <div class="proposals-read-seller">
    <form-select
      :options="options"
      :value="proposal.seller.id"
      class="proposals-read-seller-select"
      label="Vendedor"
      @input="update"
    />

    <modal-confirmation
      v-if="updating"
      :loading="loading"
      title="Atualizar status"
      @close="close"
      @confirm="submit"
    >
      Alterar o vendedor da proposta para <b>{{ name }}</b>?
    </modal-confirmation>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import namelize from '@sdk/helpers/formatters/namelize';

  import FormSelect from '@cordel/components/Form/Select.vue';
  import ModalConfirmation from '@cordel/components/Modal/Confirmation.vue';

  export default {
    name: 'ProposalsReadSeller',
    components: {
      FormSelect,
      ModalConfirmation,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        updating: null,
      };
    },
    computed: {
      ...mapState([
        'proposals',
        'sellers',
      ]),

      loading() {
        return this.proposals.update.loading;
      },

      name() {
        return namelize(this.sellers.list.items[this.updating].name);
      },
      options() {
        const { seller } = this.proposal;
        const list = Object.values(this.sellers.list.items);

        if (seller.id && !this.sellers.list.items[seller.id]) {
          list.push(seller);
        }

        return list.map(s => ({
          label: namelize(s.name),
          value: s.id,
        }));
      },
    },
    mounted() {
      this.$store.dispatch('sellers/list');
    },
    methods: {
      update(value) {
        if (this.proposal.seller.id === value) {
          return;
        }

        this.updating = value;
      },

      close() {
        this.updating = null;
      },
      submit() {
        this.$store.dispatch('proposals/update', {
          id: this.proposal.id,
          seller_id: this.updating,
        }).then(this.close);
      },
    },
  };
</script>

<style lang="scss">
  .proposals-read-seller-select {
    .cordel-select-button {
      padding: 0;
    }

    .cordel-select-text {
      font-weight: var(--cordel-font-weight-bold);
    }

    .cordel-select-chevron {
      color: inherit;
      margin-left: var(--cordel-spacing-micro);
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-seller {
  }

  .proposals-read-seller-select {
    box-shadow: none;
  }
</style>
